module.exports = __webpack_public_path__ + "e39decfe3c26d60c848b1df1f7bd007c.png";